import React from 'react';
import Select from '../../../components/ui/Select';
import Input from '../../../components/ui/Input';
import Button from '../../../components/ui/Button';

const FilterControls = ({ filters, onFilterChange, onClearFilters, hasActiveFilters }) => {
  const complianceOptions = [
    { value: 'all', label: 'All Statuses' },
    { value: 'compliant', label: 'Compliant' },
    { value: 'warning', label: 'Warning' },
    { value: 'critical', label: 'Critical' }
  ];

  const sortOptions = [
    { value: 'name', label: 'Site Name' },
    { value: 'client', label: 'Client Name' },
    { value: 'startDate', label: 'Start Date' },
    { value: 'endDate', label: 'End Date' },
    { value: 'compliance', label: 'Compliance Status' }
  ];

  return (
    <div className="bg-card rounded-lg shadow-elevation-2 border border-border p-4 md:p-6">
      <div className="flex items-center justify-between mb-4">
        <div className="flex items-center gap-2">
          <h3 className="text-lg font-semibold text-foreground font-heading">Filters</h3>
          {hasActiveFilters && (
            <span className="px-2 py-0.5 text-xs font-medium bg-accent/10 text-accent rounded-full">
              Active
            </span>
          )}
        </div>
        <Button
          variant="ghost"
          size="sm"
          onClick={onClearFilters}
          iconName="X"
          iconPosition="left"
          disabled={!hasActiveFilters}
        >
          Clear
        </Button>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
        <Input
          type="search"
          placeholder="Search sites..."
          value={filters?.search}
          onChange={(e) => onFilterChange('search', e?.target?.value)}
          className="w-full"
        />

        <Select
          placeholder="Compliance Status"
          options={complianceOptions}
          value={filters?.compliance}
          onChange={(value) => onFilterChange('compliance', value)}
        />

        <Select
          placeholder="Sort By"
          options={sortOptions}
          value={filters?.sortBy}
          onChange={(value) => onFilterChange('sortBy', value)}
        />

        <Input
          type="text"
          placeholder="Client name..."
          value={filters?.client}
          onChange={(e) => onFilterChange('client', e?.target?.value)}
          className="w-full"
        />
      </div>
    </div>
  );
};

export default FilterControls;